/* Filthy Clean — clone the footer USP bar (Free Delivery / Money-Back / Profits Pledged)
   into the bottom of the mobile menu drawer. The drawer markup is a stock Liquid file we don't
   edit, so we inject additively here. Cloning the footer's .fc2-usp items keeps the copy in one
   place (edit the footer bar, the menu updates too). Idempotent + re-runs on menu open. */
(function () {
  function inject() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer || drawer.querySelector('.fc-menu-usps')) return;
    var src = document.querySelectorAll('.fc2-uspbar .fc2-usp');
    if (!src.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'fc-menu-usps';
    src.forEach(function (u) {
      var c = u.cloneNode(true);
      c.removeAttribute('tabindex'); // decorative in the menu
      wrap.appendChild(c);
    });
    drawer.appendChild(wrap);
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(inject);
  // the drawer can be re-rendered by the Section Rendering API on navigation — re-inject on open
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu, .menu-drawer-container')) setTimeout(inject, 30);
  }, true);
})();
